import MaterialSinglePropertyAssigner from "../material-single-property-assigner.js";

class MaterialSinglePropertyMultiAssigner extends MaterialSinglePropertyAssigner {
    constructor(assigners) {
        super();
        this._assigners = Object.assign({}, assigners);
    }

    setProperty(material, value) {
        for (const key in this._assigners) {
            this._assigners[key].setProperty(material.materials[key], value);
        }
    }
}

export default MaterialSinglePropertyMultiAssigner;
